import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';

import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { MainHeaderAngularModule } from 'rev-portal/navigation/mainHeader/MainHeader.AngularModule';
import { RecordingAngularModule } from 'rev-portal/media/recording/RecordingAngular.Module';
import { VideoReportsModule } from 'rev-portal/media/videos/videoReports/VideoReports.Module';
import { VideoTextStatusAngularModule } from 'rev-portal/media/videos/videoTextStatus/VideoTextStatus.AngularModule';
import { VideoPlaybackSettingsMenuModule } from 'rev-portal/media/videos/videoPlaybackSettingsMenu/VideoPlaybackSettingsMenu.Module';
import { VideoPlackbackStatusMsgModule } from 'rev-portal/media/videos/videoPlaybackStatusMsg/VideoPlaybackStatusMsg.Module';

import { AccentHeaderAngularModule } from 'rev-shared/ui/accentHeader/AccentHeader.AngularModule';
import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { CheckboxAngularModule } from 'rev-shared/ui/checkbox/CheckboxAngular.Module';
import { CssRulesAngularModule } from 'rev-shared/ui/css/Css.AngularModule';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { DialogRegistrationService } from 'rev-shared/ui/dialog/DialogRegistration.Service';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { FileUploadAngularModule } from 'rev-shared/ui/fileUpload/FileUpload.AngularModule';
import { FlickityCarouselModule } from 'rev-shared/ui/flickityCarousel/FlickityCarousel.AngularModule';
import { FormDirectivesAngularModule } from 'rev-shared/util/directives/form/FormDirectivesAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { PipesAngularModule } from 'rev-shared/pipes/Pipes.AngularModule';
import { ReportsServiceDownMsgModule } from 'rev-shared/ui/reports/reportsDown/ReportsServiceDownMsg.Module';
import { SearchInputModule } from 'rev-shared/ui/searchInputAngular/SearchInput.Module';
import { SecurityAngularModule } from 'rev-shared/security/SecurityAngular.Module';
import { SelectAngularModule } from 'rev-shared/ui/select/SelectAngular.Module';
import { SidebarLayoutModule } from 'rev-shared/ui/sidebarLayoutAngular/SidebarLayout.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { TextInputAngularModule } from 'rev-shared/ui/text-input/TextInputAngular.Module';
import { VBrickSharedPublicVideoPasswordModule } from 'rev-shared/media/publicVideoPassword/PublicVideoPassword.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { ValidationModule } from 'rev-shared/util/directives/form/validation/Validation.AngularModule';
import { VbDateTimePickerModule } from 'rev-shared/ui/dateTimePicker/VbDateTimePicker.Module';
import { VbDropdownMenuModule } from 'rev-shared/ui/dropdown-menu/VbDropdownMenu.Module';
import { VbPageHeaderModule } from 'rev-shared/ui/pageHeader/VbPageHeader.Module';
import { VbProfilePictureModule } from 'rev-shared/ui/profile/VbProfilePicture.Module';
import { VbRatingModule } from 'rev-shared/ui/rating/VbRating.Module';
import { VbTextAreaModule } from 'rev-shared/ui/textArea/VbTextArea.Module';
import { VbUiDatePickerModule } from 'rev-shared/ui/datePicker/VbUiDatePicker.Module';
import { VbUiHtmlEditorModule } from 'rev-shared/htmlEditor/VbUiHtmlEditor.Module';
import { VbUiShareEmbedModule } from 'rev-shared/media/shareEmbed/VbUiShareEmbed.Module';
import { VbUiShareLinkModule } from 'rev-shared/media/shareLink/VbUiShareLink.Module';
import { VbUiToggleContentDisplayAngularModule } from 'rev-shared/ui/toggleContentDisplay/VbUiTogleContentDisplay.AngularModule';
import { VideoChapterModule } from 'rev-shared/media/videoChapter/VideoChapter.Module';
import { VideoPlayerAngularModule } from 'rev-shared/videoPlayer/VideoPlayerAngular.Module';
import { VideoPlaylistModule } from 'rev-shared/media/videoPlaylist/VideoPlaylist.Module';

import { AddPlaylistComponent } from './AddPlaylist.Component';
import { AddVideoCommentComponent } from './AddVideoComment.Component';
import { CategoriesAndTagsStyleComponent } from './CategoriesAndTagsStyle.Component';
import { InThisVideoAngularModule } from './inThisVideo/InThisVideoAngular.Module';
import { PrepositionDialogComponent } from './PrepositionDialog.Component';
import { ProgressBarAngularModule } from 'rev-shared/ui/progressBar/ProgressBarAngular.Module';
import { PulseModule } from './pulse/Pulse.Module';
import { ReplaceVideoDialogComponent } from './ReplaceVideoDialog.Component';
import { ReportVideoDialogComponent } from './ReportVideoDialog.Component';
import { VideoApprovalProcessModule } from './approvalProcess/VideoApprovalProcess.Module';
import { VideoBasicInfoComponent } from './VideoBasicInfo.Component';
import { VideoCategoriesComponent } from './VideoCategories.Component';
import { VideoChaptersModule } from './videoChapters/VideoChapters.Module';
import { VideoCommentComponent } from './VideoComment.Component';
import { VideoCommentContainerComponent } from './VideoCommentContainer.Component';
import { VideoCommentListComponent } from './VideoCommentList.Component';
import { VideoCommentMenuComponent } from './VideoCommentMenu.Component';
import { VideoCustomFieldsComponent } from './VideoCustomFields.Component';
import { VideoDownloadComponent } from './VideoDownload.Component';
import { VideoPlaybackComponent } from './VideoPlayback.Component';
import { VideoPlaybackOverlayDialogComponent } from './VideoPlaybackOverlayDialog.Component';
import { VideoPlaybackProcessingProgressBarComponent } from './VideoPlaybackProcessingProgressBar.Component';
import { VideoPlaybackReportsComponent } from './VideoPlaybackReports.Component';
import { VideoPlaybackReportsService } from './VideoPlaybackReports.Service';
import { VideoPlaybackSidebarPanelComponent } from './VideoPlaybackSidebarPanel.Component';
import { VideoPlaylistComponent } from './VideoPlaylist.Component';
import { VideoPlaylistContainerComponent } from './VideoPlaylistContainer.Component';
import { VideoPlaylistHeaderComponent } from './VideoPlaylistHeader.Component';
import { VideoPulseModule } from './pulse/VideoPulseAngular.Module';
import { VideoRatingComponent } from './VideoRating.Component';
import { VideoShareContainerComponent } from './VideoShareContainer.Component';
import { VideoSupplementalContentComponent } from './VideoSupplementalContent.Component';
import { VideoTagsComponent } from './VideoTags.Component';
import { states } from './StateDeclarations';

const components = [
	AddPlaylistComponent,
	AddVideoCommentComponent,
	CategoriesAndTagsStyleComponent,
	PrepositionDialogComponent,
	ReplaceVideoDialogComponent,
	ReportVideoDialogComponent,
	VideoBasicInfoComponent,
	VideoCategoriesComponent,
	VideoCommentComponent,
	VideoCommentContainerComponent,
	VideoCommentListComponent,
	VideoCommentMenuComponent,
	VideoCustomFieldsComponent,
	VideoDownloadComponent,
	VideoPlaybackComponent,
	VideoPlaybackOverlayDialogComponent,
	VideoPlaybackProcessingProgressBarComponent,
	VideoPlaybackReportsComponent,
	VideoPlaybackSidebarPanelComponent,
	VideoPlaylistComponent,
	VideoPlaylistContainerComponent,
	VideoPlaylistHeaderComponent,
	VideoRatingComponent,
	VideoShareContainerComponent,
	VideoSupplementalContentComponent,
	VideoTagsComponent
];

@NgModule({
	declarations: components,
	entryComponents: components,
	imports: [
		AccentHeaderAngularModule,
		ButtonsAngularModule,
		CheckboxAngularModule,
		CommonModule,
		CssRulesAngularModule,
		DateAngularModule,
		DialogAngularModule,
		DirectivesAngularModule,
		FileUploadAngularModule,
		FlickityCarouselModule,
		FormDirectivesAngularModule,
		FormGroupAngularModule,
		FormsModule,
		InThisVideoAngularModule,
		MainHeaderAngularModule,
		NgxTrimDirectiveModule,
		PipesAngularModule,
		ProgressBarAngularModule,
		PulseModule,
		RatingModule,
		RecordingAngularModule,
		ReportsServiceDownMsgModule,
		SearchInputModule,
		SecurityAngularModule,
		SelectAngularModule,
		SidebarLayoutModule,
		SpinnerAngularModule,
		TextInputAngularModule,
		TooltipModule,
		TranslateModule,
		UIRouterModule.forChild({ states }),
		VBrickSharedPublicVideoPasswordModule,
		ValidationAngularModule,
		ValidationModule,
		VbDateTimePickerModule,
		VbDropdownMenuModule,
		VbPageHeaderModule,
		VbProfilePictureModule,
		VbRatingModule,
		VbTextAreaModule,
		VbUiDatePickerModule,
		VbUiHtmlEditorModule,
		VbUiShareEmbedModule,
		VbUiShareLinkModule,
		VbUiToggleContentDisplayAngularModule,
		VideoApprovalProcessModule,
		VideoChapterModule,
		VideoChaptersModule,
		VideoPlackbackStatusMsgModule,
		VideoPlaybackSettingsMenuModule,
		VideoPlayerAngularModule,
		VideoPlaylistModule,
		VideoPulseModule,
		VideoReportsModule,
		VideoTextStatusAngularModule
	],
	providers: [
		VideoPlaybackReportsService
	]
})
export class VideoPlaybackAngularModule {

	constructor(dialog: DialogRegistrationService) {
		dialog.register('ReportVideo', { component: ReportVideoDialogComponent });
	}
}
